export const NavBarDesktopStyle = theme => ({
	root: {
		borderRadius: 0,
		width: 360,
		maxWidth: 360,
		backgroundColor: theme.palette.background.paper
	},
	inline: {
		display: "inline",
		fontSize: "1rem",
		fontWeight: 500
	},
	margin: {
		margin: theme.spacing.unit * 2
	},
	badge: {
		top: 6,
		right: 6
	},
	avatar: {
		width: 35,
		height: 35
	},
	button: {
		margin: theme.spacing.unit
	}
})
